import React from 'react'

import footer_1 from './static/img/icons/ico-footer1.svg'
import footer_2 from './static/img/icons/ico-footer2.svg'
import footer_3 from './static/img/icons/ico-footer3.svg'
import {Link} from 'react-router-dom'

function Footer() {
  return (
    <footer>
        <div className="footer_container">
            <div className="footer_container_inner_wrapper">
                <div className="footer_column_1">
                    <Link to="/"><span className="btn_animation white">Main</span></Link>
                    <Link to="/services"><span className="btn_animation white">Services</span></Link>
                    <Link to="/about-company"><span className="btn_animation white">About company</span></Link>
                    <Link to="/news-articles"><span className="btn_animation white">News and articles</span></Link>
                    <Link to="/gallery"><span className="btn_animation white">Gallery</span></Link>
                </div>

                <div className="footer_column_2">
                    <p>Contacts</p>
                    <div className="row_2"><img src={footer_1} alt="" /><span>Turkmenistan, Ashgabat city, 1945 street, 98 “Altyn Asyr” Shopping Centre</span></div>
                    <a href="mailto:infoecosu@gmail.com" className="row_3"><img src={footer_2} alt="" /><span>infoecosu@gmail.com</span></a>
                    <a href="tel:+99365650465" className="row_4"><img src={footer_3} alt="" /><span>+993 (65) 65 04 65</span></a>
                </div>
            </div>
            <div className="footer_bottom">
                <a href="">Powered by Sanly tilsimat</a>
                <div className="visitors_number">
                    <img src="img/icons/ico-footer4.svg" alt="" />
                    <span>1056</span>
                </div>
            </div>
        </div>
    </footer>
  )
}

export default Footer